// extracted by mini-css-extract-plugin
export default {"rating":"iD-z","numberOfStars":"jD-z","count":"kD-z","barGraphSpacing":"lD-z","barGraph":"mD-z"};